import { Monitor, Moon, Sun } from 'lucide-react';
import { type Theme, useTheme } from '@/components/theme-provider';
import { cn } from '@/lib/utils';

const OPTIONS: { value: Theme; icon: typeof Sun; label: string }[] = [
  { value: 'light', icon: Sun, label: 'Light' },
  { value: 'system', icon: Monitor, label: 'System' },
  { value: 'dark', icon: Moon, label: 'Dark' },
];

export function ThemeSwitcher({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  return (
    // Matches the view switches on timesheets/approvals: white track with the
    // shared taupe border (`data-surface="panel"`), blue chip on the active
    // option. `bg-muted` here was a cream track that read as part of the page.
    <div
      data-surface="panel"
      data-slot="toggle-group"
      className={cn(
        'inline-flex items-center gap-0.5 rounded-md border light:bg-card p-0.5',
        className,
      )}
    >
      {OPTIONS.map(({ value, icon: Icon, label }) => {
        const active = theme === value;
        return (
          <button
            key={value}
            type="button"
            aria-pressed={active}
            aria-label={label}
            title={label}
            onClick={() => setTheme(value)}
            data-slot="toggle-group-item"
            className={cn(
              'inline-flex h-7 w-7 items-center justify-center rounded-sm transition-colors',
              'text-muted-foreground hover:text-foreground',
              active && 'bg-background text-foreground shadow-sm',
            )}
          >
            <Icon className="size-3.5" />
          </button>
        );
      })}
    </div>
  );
}
